import { createContext } from 'react';

import type { Session } from '@/lib/authApi';

export interface AuthState {
  readonly session: Session | null;
  /** Verdadeiro até a primeira tentativa de restaurar a sessão terminar. */
  readonly isRestoring: boolean;
  readonly signIn: (email: string, password: string) => Promise<Session>;
  readonly signOut: () => Promise<void>;
}

/**
 * Contexto de autenticação.
 *
 * Fica isolado do provider e do hook porque o Fast Refresh do Vite exige que um
 * módulo exporte só componentes. Sem essa separação o recarregamento a quente
 * para de funcionar em toda a árvore de autenticação.
 */
export const AuthContext = createContext<AuthState | null>(null);
